import React from 'react'
import Search from './Google'

import { InitialFocus } from './LoginModal'

const Login = () => {
  return (
    <div>

      <InitialFocus/>
      {/* <Search/> */}

    </div>
  )
}

export default Login